import { render } from "./PaysheetShiftsTab.vue?vue&type=template&id=adb06f2e"
import script from "./PaysheetShiftsTab.vue?vue&type=script&lang=js"
export * from "./PaysheetShiftsTab.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__